module.exports = __webpack_public_path__ + "img/touch.e2134486.svg";